import { useReducer } from 'react';

function reducer(state, action) {
  switch (action.type) {
    case 'callback':
      return action.cb(state);
    case 'update':
      return {
        ...state,
        ...action.payload
      };
    case 'reset':
      return action.payload;
    default:
      return state;
  }
}

export default function useStore(initialState = {}) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return { state: state || {}, dispatch };
}
